const enCore = {
    // ── Common ──
    app_name: 'Seeday',
    confirm: 'Save',
    cancel: 'Cancel',
    save: 'Save',
    delete: 'Delete',
    retry: 'Retry',
    expand: 'Expand',
    close: 'Close',
    notification_action_confirm: '✓ Confirm',
    notification_action_deny: 'I am busy',
    notification_action_view_report: 'View diary',
    notification_action_grow_plant: 'Grow plant',
    notification_action_weekend_confirm: 'Log now',
    notification_action_weekend_deny: 'Ignore',
    notification_action_open_chat: 'Open chat',
    notification_action_still_yes: '✓ Still on it',
    notification_action_still_no: 'I am busy',
    loading: 'Loading…',
    app_loading_wait: 'Loading, just a moment...',
    no_data: 'No data available',
    // ── Duration formatting ──
    duration_hours_minutes: '{{hours}}h {{mins}}m',
    duration_minutes: '{{mins}}m',
    duration_label: 'Duration {{duration}}',
    elapsed_label: 'Duration: {{duration}}',
    // ── Header ──
    header_login: 'Log in / Sign up',
    header_confirm_logout: 'Are you sure you want to log out?',
    // ── Bottom Nav ──
    nav_record: 'Track',
    nav_report: 'Reports',
    nav_profile: 'Profile',
    // ── Chat / Record Page ──
    chat_title: 'Track',
    chat_history_readonly: 'Viewing a past date — switch back to today to add records',
    chat_ongoing: 'Tracking',
    chat_current_activity: 'Tracking: ',
    chat_date_section_hint: 'Time seen today',
    chat_placeholder_mood: 'Log your mood (e.g., excited)… Tap ❤️ to switch to activities',
    chat_placeholder_activity: 'Log your activity (e.g., lunch)… Tap ❤️ to switch to mood',
    chat_placeholder_neutral: 'Capture this moment, the tree will remember it',
    chat_historical_read_only: 'Past dates are read-only',
    chat_switch_to_activity: 'Track activities',
    chat_switch_to_mood: 'Log mood',
    chat_confirm_delete: 'Are you sure you want to delete this entry?',
    chat_edit_record: 'Edit Entry',
    chat_insert_record: 'Insert Entry',
    chat_label_content: 'Activity',
    chat_placeholder_content: 'What were you doing…',
    chat_label_start_time: 'Start Time',
    chat_start_time_no_future: 'Start time cannot be in the future',
    chat_label_end_time: 'End Time',
    chat_title_edit: 'Edit',
    chat_title_insert: 'Insert after',
    chat_title_delete: 'Delete',
    chat_load_more_records: 'Loading more records…',
    chat_reached_oldest: '— Reached the earliest record —',
    chat_custom_label_default: 'Custom',
    chat_unknown_mood_label: 'Unlabeled',
    chat_pick_mood_for_record: 'Pick a mood for this record',
    chat_mood_note_label: 'Mood note',
    chat_mood_note_placeholder: 'Write how you felt during this activity…',
    chat_adjust_mood_label: 'Adjust mood label',
    chat_duration_logged: 'Logged {{minutes}} min',
    chat_end_activity: 'End',
    chat_convert_to_activity: 'Convert to activity',
    chat_convert_to_mood: 'Convert to mood',
    chat_magic_pen_open: 'Magic Pen',
    chat_magic_pen_title: 'Magic Pen',
    chat_magic_pen_subtitle: 'Backfill missed activities or extract to-dos',
    chat_magic_pen_confirm: 'Write All',
    chat_magic_pen_mode_on: 'Magic Pen mode on',
    chat_magic_pen_mode_off: 'Magic Pen mode off',
    chat_magic_pen_retry_failed: 'Retry Failed',
    chat_magic_pen_cancel: 'Cancel',
    chat_magic_pen_group_activity: 'Activity Backfill',
    chat_magic_pen_group_todo: 'New To-dos',
    chat_magic_pen_group_unparsed: 'Unrecognized',
    chat_magic_pen_group_auto_written: 'Auto-written',
    chat_magic_pen_auto_written_badge: 'Auto-written',
    chat_magic_pen_undo_auto_written: 'Undo',
    chat_magic_pen_linked_mood_label: 'Linked mood',
    chat_magic_pen_unparsed_hint: 'These could not be auto-recognized. You can add them manually via the main input.',
    chat_magic_pen_missing_time: 'Start & end time required',
    chat_magic_pen_estimated_time: 'Estimated time - please confirm',
    chat_magic_pen_invalid_time: 'Invalid time range',
    chat_magic_pen_future_time: 'End time cannot be in the future',
    chat_magic_pen_cross_day: 'Start and end must be on the same day',
    chat_magic_pen_overlap: 'Time overlaps with another item',
    chat_magic_pen_overlap_ongoing: 'Time overlaps with an ongoing activity',
    chat_magic_pen_overlap_hint: 'Conflicts with "{{activity}}" - please adjust',
    chat_magic_pen_partial_success: 'Some items failed, you can retry',
    chat_magic_pen_ai_error: 'Analysis failed, please try again',
    chat_magic_pen_success_summary: 'Backfilled {{activityCount}} activities, added {{todoCount}} to-dos',
    chat_magic_pen_item_success: 'Saved',
    chat_magic_pen_item_error: 'Save failed',
    chat_magic_pen_upgrade_title: 'Magic Pen is a Pro feature',
    chat_magic_pen_upgrade_desc: 'Upgrade to Pro to use Magic Pen for extracting activities and to-dos from one sentence.',
    chat_magic_pen_upgrade_cta: 'Upgrade to Pro',
    chat_magic_pen_upgrade_later: 'Maybe later',
    // ── Todo Page ──
    todo_title: 'Tasks',
    todo_filter_daily: 'Today',
    todo_filter_weekly: 'This Week',
    todo_filter_monthly: 'This Month',
    todo_empty: 'No tasks yet',
    todo_add: 'New Task',
    todo_edit: 'Edit Task',
    todo_label_content: 'Task Name',
    todo_placeholder_content: 'e.g., Read a book',
    todo_label_priority: 'Priority',
    todo_label_recurrence: 'Repeat',
    todo_label_category: 'Category',
    todo_placeholder_custom_category: 'New category…',
    todo_delete_confirm: 'Delete this task',
    todo_delete_recurring_title: 'This is a recurring task',
    todo_delete_recurring_desc: 'Choose how to delete',
    todo_delete_today_only: 'Just today',
    todo_delete_all_future: 'Delete all future',
    todo_duration: 'Duration {{minutes}} min',
    todo_pin: 'Pin',
    todo_unpin: 'Unpin',
    todo_start: 'Start timer',
    todo_in_progress: 'In progress',
    // Priority labels
    priority_urgent_important: 'Urgent & Important',
    priority_important_not_urgent: 'Important, Not Urgent',
    priority_urgent_not_important: 'Urgent, Not Important',
    priority_not_important_not_urgent: 'Not Important, Not Urgent',
    // Recurrence labels
    recurrence_none: 'Never',
    recurrence_daily: 'Daily',
    recurrence_weekly: 'Weekly',
    recurrence_monthly: 'Monthly',
    // ── Report Page ──
    report_title: 'Diary',
    report_calendar_view: 'Calendar',
    report_daily: 'Daily',
    report_weekly: 'Weekly',
    report_monthly: 'Monthly',
    report_custom: 'Personalized',
    report_completed: 'Completed',
    report_total_tasks: 'Total Tasks',
    report_completion_rate: 'Completion Rate',
    report_habit_tracking: 'Habits',
    report_checked: 'Done',
    report_unchecked: 'Pending',
    report_quadrant_distribution: 'Priority Quadrant',
    report_completion_trend: 'Completion Trend',
    report_activity: 'Activity',
    report_activity_records: 'Activity Records',
    report_ai_diary_analysis: 'AI Diary Insights',
    report_ai_diary_waiting: '{{companion}} is waiting for your first entry today.',
    report_generate_diary: 'View Today\'s Observation',
    report_generate_confirm: 'You can only generate one observation per day. Generate now?',
    report_generating: '{{companion}} is writing...',
    report_generating_variant_1: '{{companion}} is carefully sorting through today\'s moments and writing your diary…',
    report_generating_variant_2: '{{companion}} is turning today\'s memories into words. Give them a tiny moment~',
    report_generating_variant_3: '{{companion}} is organizing today\'s mood and rhythm...',
    report_generating_variant_4: '{{companion}} has received today\'s records and is writing now...',
    report_generating_patience: 'Delivering notes across light‑years takes time — please wait 1‑2 minutes',
    report_ai_diary_header: 'Today\'s AI Diary',
    report_coming_soon: 'Coming Soon',
    report_weekly_coming_soon: 'Weekly report coming soon',
    report_monthly_coming_soon: 'Monthly report coming soon',
    report_custom_coming_soon: 'Personalized report coming soon',
    report_completed_tasks: 'Completed Tasks',
    report_all_tasks: 'All Tasks',
    report_no_tasks: 'No tasks',
    report_close_detail: 'Close report detail',
    report_error_unknown: 'Unknown error',
    report_activity_category: 'Activity Breakdown',
    report_view_diary_book: 'Diary Book',
    report_generate_button: 'Generate Diary',
    report_generate_success: 'Today\'s diary has been generated.',
    report_generate_already: 'The diary is already generated. Go check it in Diary Book~',
    report_early_tip: 'The diary can only be generated once. Come back after 8:00 PM.',
    report_early_tip_ok: 'Got it',
    report_back_diary_book: 'Diary Book',
    report_generate_plant: 'Generate Plant',
    report_section_collapse: 'Collapse',
    report_section_expand: 'Expand',
    report_todo_section: 'To-Do',
    report_upgrade_title: 'Upgrade to Pro',
    report_upgrade_desc: 'AI Observation Diary is a Pro-exclusive feature. Upgrade to unlock daily AI-generated diary entries.',
    report_upgrade_btn: 'Get Pro Now',
    report_upgrade_later: 'Maybe Later',
    report_teaser_unlock: '✨ Unlock tonight\'s full story →',
    report_swipe_hint: '← Swipe left for AI diary & notes',
    report_my_diary: 'My Diary',
    report_diary_placeholder: 'Write down today\'s mood and feelings…',
    report_diary_empty: 'No notes left…',
    report_save: 'Save',
    report_habit_checkin: 'Habit Check-in',
    report_goal_progress: 'Goal Progress',
    report_goal_done_today: 'Done today',
    report_goal_not_today: 'Not today',
    report_recurring_tasks: 'Recurring Tasks',
    report_task_priority: 'Task Priority',
    report_root_section_title: 'Root Growth',
    report_root_section_subtitle: 'Your daytime activities keep extending the roots.',
    report_root_empty_title: 'The soil is gathering energy',
    report_root_empty: 'No visible roots yet. Complete at least a 5-minute activity to sprout.',
    plant_section_generated_badge: 'Generated today',
    plant_generate_button: 'Generate Plant',
    plant_generating: 'Your roots are condensing into today\'s plant...',
    plant_generate_done_button: 'Generated Today',
    plant_generate_try_after_20: 'Try after 20:00',
    plant_generate_locked_hint: 'Roots are still growing. Come back after 8 PM.',
    plant_generate_locked_with_diary_hint: 'Roots are still growing. After 8:00 PM you can generate both today\'s plant and diary.',
    plant_early_activities: 'You\'ve logged {{count}} activities today',
    plant_generate_ready_hint: 'Your roots are ready. You can generate today\'s plant now.',
    plant_generate_confirm: 'Generate today\'s plant now? This action is irreversible for today.',
    plant_generate_success: 'Today\'s plant has been generated.',
    plant_generate_already: 'Today\'s plant is already generated.',
    plant_generate_empty_day: 'No activity recorded today. The soil is waiting.',
    plant_generate_empty_day_fallback: 'No eligible activity record yet. Log one moment first, then come back tonight.',
    plant_generate_monthly_exhausted: 'All plants for this root type have already been generated this month. The candidate pool resets next month.',
    plant_generate_failed: 'Generation failed. Please try again later.',
    plant_reveal_title: 'Today\'s Plant Reveal',
    plant_reveal_subtitle: 'Today\'s roots are now sealed into a plant. Tomorrow starts a new growth cycle.',
    plant_reveal_special_air: 'Today is an airy low-load day, and your plant keeps that lighter rhythm.',
    plant_reveal_special_entertainment: 'Today leans toward entertainment and recovery, and your plant reflects that ease.',
    plant_image_alt: 'Today\'s plant image',
    plant_image_missing: 'Plant artwork is loading. Please check back soon.',
    plant_detail_title: 'Root Detail',
    plant_detail_activity: 'Activity',
    plant_detail_time_range: 'Time range',
    plant_detail_category: 'Category',
    plant_detail_duration: 'Duration',
    plant_detail_focus: 'Focus',
    plant_focus_high: 'High focus',
    plant_focus_medium: 'Medium focus',
    plant_direction_left_bottom: 'Left',
    plant_direction_left_top: 'Center-left',
    plant_direction_top: 'Center',
    plant_direction_right_top: 'Center-right',
    plant_direction_right_bottom: 'Right',
    plant_canvas_reset: 'Reset',
    plant_category_work_study: 'Work & Study',
    plant_category_exercise: 'Exercise',
    eco_sphere_mood_label: 'Mood',
    eco_sphere_activity_label: 'Activity',
    eco_sphere_empty_label: 'Coming Soon',
    eco_sphere_diary_label: 'Diary',
    eco_sphere_mood_energy_title: 'Mood Energy Today',
    eco_sphere_no_mood_data: 'No mood data yet. Share how you feel!',
    eco_sphere_no_activity_data: 'No activity data yet.',
    eco_sphere_night_hint: 'This data will be captured in tonight\'s diary.',
    diary_nav_prev: 'Previous day',
    diary_nav_next: 'Next day',
    diary_back_to_shelf: 'Back',
    diary_shelf_count: '{{count}} months collected',
    diary_days_count: '{{count}} days',
    diary_shelf_open_calendar: 'Select Date',
    diary_shelf_back_year: 'Back to year',
    diary_shelf_no_diary: 'No diary for this date',
    diary_shelf_open_date: 'Open {{date}}',
    diary_shelf_search_hint: 'Type numbers to find that day, or words to search what you\'ve written～',
    diary_shelf_text_no_results: 'No matching diary found',
    diary_shelf_text_results_count: '{{count}} found',
    diary_shelf_field_diary: 'diary',
    diary_shelf_field_observation: 'observation',
    diary_shelf_field_activity: 'activity',
    diary_shelf_field_mood: 'mood',
    diary_cover: 'Diary cover',
    diary_cover_subtitle: 'Companion Notes',
    diary_back_cover: 'Back cover',
    diary_day_n: 'Day {{n}}',
    diary_double_tap_open: 'Double tap to open',
    diary_double_tap_zoom: 'Double tap to zoom',
    diary_star_count: '{{count}} stars',
    diary_expanded_ai_observation: 'AI Observation Notes',
    diary_expanded_ai_pending: 'AI is organizing notes…',
    diary_expanded_ai_empty: 'No AI notes yet',
    diary_expanded_today_after_8: 'Today\'s diary will be generated after 8:00 PM',
    diary_expanded_no_diary: 'No diary record yet',
    diary_expanded_activity: 'Activity Breakdown',
    diary_expanded_mood: 'Today\'s Mood',
    diary_expanded_my_diary: 'My Diary',
    diary_expanded_no_note: 'No note left…',
    plant_save_card: 'Save Card',
    plant_tap_to_flip: 'Tap to flip',
    plant_card_diary_button: 'Generate Diary',
    // ── Auth Page ──
    auth_welcome_back: 'Welcome Back',
    auth_create_account: 'Create Account',
    auth_login_subtitle: 'Log in to sync your data',
    auth_register_subtitle: 'Sign up to start cloud sync',
    auth_account_label: 'Email address',
    auth_account_placeholder: 'Email address',
    auth_nickname_label: 'Nickname',
    auth_nickname_placeholder: 'Your nickname (optional)',
    auth_password_label: 'Password',
    auth_password_placeholder: 'Password',
    auth_login_button: 'Log in',
    auth_register_button: 'Sign up',
    auth_switch_to_register: 'Don\'t have an account? Sign up',
    auth_switch_to_login: 'Already have an account? Log in',
    auth_register_success: 'A verification code has been sent to your email. Enter it below to complete sign up.',
    auth_otp_placeholder: 'Enter 6-digit code',
    auth_resend_code: 'Resend code',
    auth_verify_button: 'Verify',
    auth_error_rate_limit: 'Too many requests — please try again later (email rate limited)',
    auth_error_invalid_credentials: 'Incorrect email or password',
    auth_error_user_exists: 'This email is already registered',
    auth_error_password_short: 'Password must be at least 6 characters',
    auth_error_invalid_grant: 'Login information is invalid or expired',
    auth_error_invalid_account: 'Please enter a valid email address',
    auth_error_generic: 'An error occurred: ',
    auth_select_avatar: 'Select avatar',
    auth_close: 'Close',
    auth_more: 'More',
    auth_change_avatar: 'Change avatar',
    avatar_alt: 'Avatar',
    auth_google_signin: 'Continue with Google',
    auth_apple_signin: 'Sign in with Apple',
    auth_or_divider: 'or',
    // ── AI Annotation Bubble ──
    annotation_condensing: 'Crystallizing…',
    annotation_condense: 'Crystallize',
    annotation_condensed: 'Crystallized',
    annotation_hover_pause: 'Paused on hover',
    annotation_suggestion_started: 'Started ✓',
    // ── Stardust Card ──
    stardust_loading: 'Retrieving memory…',
    stardust_error_default: 'Failed to load memory — please try again later',
    stardust_from: 'From {{name}} · {{date}}',
    // ── Todo Categories ──
    category_study: 'Study',
    category_work: 'Work',
    category_social: 'Social',
    category_life: 'Life',
    category_entertainment: 'Entertainment',
    category_health: 'Health',
    // ── Mood Labels ──
    mood_happy: 'Happy',
    mood_calm: 'Calm',
    mood_focused: 'Focused',
    mood_satisfied: 'Satisfied',
    mood_tired: 'Tired',
    mood_anxious: 'Anxious',
    mood_bored: 'Bored',
    mood_down: 'Down',
    // ── Language Switcher ──
    language_switch: 'Language',
    language_en: 'EN',
    language_zh: '中',
    weekday_short_sun: 'Sun',
    weekday_short_mon: 'Mon',
    weekday_short_tue: 'Tue',
    weekday_short_wed: 'Wed',
    weekday_short_thu: 'Thu',
    weekday_short_fri: 'Fri',
    weekday_short_sat: 'Sat',
    // ── Growth Page ──
    nav_growth: 'Growth',
    growth_title: 'Growth',
    growth_daily_goal_title: 'Life Goal',
    growth_daily_goal_subtitle: 'Writing down your goal daily can increase the likelihood of achieving it by 10x',
    growth_daily_goal_placeholder: 'Write your most important goal...',
    growth_daily_goal_confirm: 'Confirm',
    growth_daily_goal_disable: 'Don\'t show again',
    growth_daily_goal_enable: 'Daily goal reminder popup',
    growth_life_goal_title: 'Life Goal Management',
    growth_life_goal_desc: 'Two-way synced with Profile, used to keep your long-term direction visible.',
    growth_life_goal_placeholder: 'Write the direction you want to keep over the long run...',
    growth_life_goal_sync_hint: 'Synced with "Profile > Life goal"',
    growth_life_goal_save: 'Save',
    growth_life_goal_saving: 'Saving...',
    growth_life_goal_saved: 'Synced to profile',
    growth_life_goal_save_failed: 'Sync failed, please retry',
    growth_life_goal_no_changes: 'No changes to save',
    growth_bottle_section: 'Habits & Goals',
    growth_bottle_section_hint: 'Craft a nutrient bottle for your plant',
    growth_add_bottle: 'Add Bottle',
    growth_add_bottle_modal_title: 'Build a New Nutrient Bottle',
    growth_bottle_name: 'Name',
    growth_bottle_name_placeholder: 'e.g., Read 30 min daily',
    growth_bottle_type: 'Type',
    growth_bottle_type_habit: 'Habit',
    growth_bottle_type_goal: 'Goal',
    growth_bottle_max_reached: 'Maximum 10 bottles reached',
    growth_bottle_achieved: 'Achieved',
    growth_bottle_irrigate_hint: 'Can be made into nutrient solution to water your plant',
    growth_bottle_irrigate: 'Water Plant',
    growth_bottle_irrigated: 'Plant Watered',
    growth_bottle_goal_confirm: 'Have you achieved this goal?',
    growth_bottle_goal_yes: 'Yes',
    growth_bottle_goal_no: 'Not yet',
    growth_bottle_round: 'Round {{round}}',
    growth_bottle_stars: '{{stars}}/21',
    growth_todo_section: 'Recent Tasks',
    growth_todo_add: 'Add Task',
    growth_todo_title_placeholder: 'Task title...',
    growth_todo_due_date: 'Due Date',
    growth_todo_priority: 'Priority',
    growth_todo_priority_high: 'High',
    growth_todo_priority_medium: 'Medium',
    growth_todo_priority_low: 'Low',
    growth_todo_link_bottle: 'Link to Bottle',
    growth_todo_none: 'None',
    growth_todo_empty: 'No tasks yet',
    growth_todo_title_required: 'Please enter a task title',
    growth_todo_complete: 'Complete task',
    growth_focus_title: 'Focus Mode',
    growth_focus_start: 'Start',
    growth_focus_end: 'End',
    growth_focus_end_confirm: 'End focus session?',
    growth_focus_summary: 'Focus duration: {{duration}}',
    growth_focus_set_duration: 'Set Duration',
    growth_focus_counting_up: 'Counting up',
    growth_focus_resting: 'Take a break',
    growth_focus_skip_rest: 'Skip break',
    todo_decompose_btn: 'Step by Step',
    todo_decompose_regenerate_btn: 'Re-breakdown',
    todo_decompose_loading: 'Breaking down...',
    todo_decompose_error: 'Failed, please retry',
    todo_decompose_empty: 'No useful steps yet, try rephrasing',
    todo_decompose_steps_label: 'Steps',
    todo_decompose_min: 'min',
    todo_sequential_focus: 'Sequential Focus',
    growth_habit_todo_prompt: 'Auto-create Daily To-Do?',
    growth_habit_todo_confirm: 'Add "{{name}}" as a daily recurring task?',
    growth_habit_todo_dismiss: 'Skip',
    growth_bottle_create_todo: 'Create To-Do',
    growth_todo_recurrence: 'Repeat',
    growth_todo_recurrence_once: 'Once',
    growth_todo_recurrence_daily: 'Daily',
    growth_todo_recurrence_weekly: 'Weekly',
    growth_todo_due_datetime: 'Due Date & Time',
    growth_todo_start: 'Start',
    growth_todo_weekly_days: 'Select Days',
    growth_todo_quick_add_placeholder: 'Add a to-do, press Enter to save...',
    todo_due_badge_today: 'Today',
    todo_due_badge_tomorrow: 'Tomorrow',
    todo_due_badge_overdue: 'Overdue',
    todo_sort_smart: 'Smart Sort',
    todo_sort_manual: 'Manual',
    growth_bottle_name_duplicate: 'A bottle with this name already exists',
    growth_bottle_todo_prompt: 'Create a to-do for "{{name}}"?',
    growth_bottle_open_detail: 'Open details for "{{name}}"',
    growth_bottle_stats_last7: 'Check-ins (7d)',
    growth_bottle_stats_streak_current: 'Current streak',
    growth_bottle_stats_streak_best: 'Best streak',
    growth_bottle_delete: 'Delete bottle',
    growth_bottle_delete_confirm: 'Delete "{{name}}"?',
    growth_bottle_sync_pending: 'Syncing',
    growth_bottle_sync_failed: 'Sync failed',
    // ── Profile Page ──
    profile_title: 'Profile',
    profile_streak: 'Greenhouse',
    profile_weekly_login_hint: '{{days}} day(s) this week',
    profile_today_activities: 'Today',
    profile_today_activities_hint: '{{count}} moment(s) today',
    profile_completed_goals: 'Goals',
    profile_completed_goals_hint: 'Bearing fruit',
    profile_ai_mode: 'AI Companion',
    profile_ai_mode_desc: 'When enabled, AI will send companion reminders based on your records.',
    profile_ai_companion_select: 'Choose companion',
    profile_ai_mode_van_subtitle: 'Emotional Healing',
    profile_ai_mode_agnes_subtitle: 'Guiding Direction',
    profile_ai_mode_zep_subtitle: 'Real-Life Candor',
    profile_ai_mode_momo_subtitle: 'Order Catalyst',
    profile_free: 'Free',
    profile_annotation_drop: 'Companion frequency',
    profile_drop_low: 'Low',
    profile_drop_medium: 'Medium',
    profile_drop_high: 'High',
    profile_daily_goal: 'Daily Life Goal',
    profile_daily_goal_desc: 'Show goal popup when entering Growth page',
    profile_long_term_profile: 'Enable Personal Memory',
    profile_long_term_profile_desc: 'Once enabled, AI remembers your shared moments and becomes a more thoughtful companion over time.',
    profile_long_term_profile_saved: 'Personal memory setting updated',
    profile_long_term_profile_save_failed: 'Failed to update personal memory setting',
    profile_routine_title: 'My Routine',
    profile_routine_desc: 'Set wake, sleep, and meal times so daily reminders can better match your rhythm.',
    profile_routine_time_section: 'Daily Schedule',
    profile_routine_save: 'Save',
    profile_routine_saving: 'Saving...',
    profile_routine_no_changes: 'No routine changes',
    profile_routine_saved: 'Routine saved',
    profile_routine_save_failed: 'Failed to save routine, please retry',
    profile_ai_memory_locked_title: 'AI Personal Memory (Pro)',
    profile_ai_memory_locked_desc: 'Upgrade to Pro to enable memory that keeps your preferences and moments over time.',
    profile_user_profile_title: 'AI Personal Memory',
    profile_user_profile_desc: 'Pro only. Save your preferences and communication style for more personal AI companionship.',
    profile_user_profile_tab_schedule: 'Schedule',
    profile_user_profile_tab_personalization: 'Personalization',
    profile_user_profile_tab_anniversaries: 'My Anniversaries',
    profile_user_profile_primary_use: 'Primary Use',
    profile_user_profile_select_placeholder: 'Select an option',
    profile_user_profile_use_life_record: 'Life record',
    profile_user_profile_use_organize_thoughts: 'Organize thoughts',
    profile_user_profile_use_emotion_management: 'Emotion management',
    profile_user_profile_use_habit_building: 'Habit building',
    profile_user_profile_wake_time: 'Wake',
    profile_user_profile_sleep_time: 'Sleep',
    profile_user_profile_breakfast: 'Breakfast',
    profile_user_profile_lunch: 'Lunch',
    profile_user_profile_dinner: 'Dinner',
    profile_user_profile_current_goal: 'Current goal',
    profile_user_profile_current_goal_placeholder: 'What do you want to push forward recently?',
    profile_user_profile_life_goal: 'Life goal',
    profile_user_profile_life_goal_placeholder: 'Optional: write a longer-term goal',
    profile_user_profile_personalization: 'Personalization',
    profile_user_profile_personalization_placeholder: 'Freely describe your likes/dislikes, interaction preferences, and communication style for AI to reference later.',
    profile_user_profile_anniversaries: 'Visible anniversaries',
    profile_user_profile_my_anniversaries: 'My anniversaries',
    profile_user_profile_anniversary_source_user: 'Added by me',
    profile_user_profile_anniversary_source_ai: 'Detected by AI',
    profile_user_profile_add_anniversary: 'Add',
    profile_user_profile_anniversary_empty: 'No anniversaries yet',
    profile_user_profile_anni_label_placeholder: 'Name this date',
    profile_user_profile_anni_repeat: 'Repeat yearly',
    profile_user_profile_remove_anniversary: 'Remove anniversary',
    profile_user_profile_anni_limit: 'You can add up to 10 anniversaries',
    profile_user_profile_save: 'Save personal memory',
    profile_user_profile_saving: 'Saving...',
    profile_user_profile_no_changes: 'No changes to save',
    profile_user_profile_partial_anniversary: 'Each anniversary needs both name and date',
    profile_user_profile_saved: 'Personal memory saved. I will get to know you better over time.',
    profile_user_profile_save_failed: 'Save failed, please retry',
    profile_snapshot_title: 'Profile Snapshot',
    profile_snapshot_desc_enabled: 'Long-term profile is enabled. Suggestions can reference these signals.',
    profile_snapshot_desc_disabled: 'Long-term profile is disabled. Data below is for local editing only.',
    profile_snapshot_meal_title: 'Meal-time hints',
    profile_snapshot_anniversary_title: 'Upcoming anniversaries',
    profile_snapshot_recall_title: 'Latest recall moment',
    profile_snapshot_empty: 'None yet',
    profile_membership: 'Membership',
    profile_upgrade: 'Upgrade to Pro · Unlock All Features',
    profile_upgrade_trial: 'Start Free Pro Trial · Unlock All Features',
    profile_upgrade_coming: 'Coming Soon',
    upgrade_back: 'Back',
    upgrade_title: 'Upgrade to Pro',
    upgrade_plan_label: 'Choose plan',
    upgrade_plan_monthly: 'Monthly',
    upgrade_plan_annual: 'Annual',
    upgrade_price_monthly: '$7.99 / month',
    upgrade_price_annual: '$99.99 / year',
    upgrade_price_monthly_note: 'Intro price, regular $9.99',
    upgrade_price_annual_note: 'Best value for long-term use',
    upgrade_feature_label: 'Unlocked features',
    upgrade_payment_source: 'Current payment channel: {{source}}',
    upgrade_continue_button: 'Continue with {{price}}',
    upgrade_restore_button: 'Restore purchase',
    upgrade_processing: 'Processing...',
    upgrade_purchase_success: 'Purchase succeeded. Pro is now active.',
    upgrade_restore_success: 'Restore succeeded. Membership status refreshed.',
    upgrade_error_iap_not_ready: 'IAP plugin is not connected on this device yet. Complete iOS native wiring and retry.',
    upgrade_error_subscription_failed: 'Subscription request failed. Please try again later.',
    upgrade_error_activate_failed: 'Subscription activation failed. Please verify purchase status and retry.',
    upgrade_error_restore_failed: 'Restore purchase failed. Please try again later.',
    upgrade_error_stripe_not_ready: 'Stripe checkout is not connected yet in this build.',
    upgrade_error_stripe_not_supported: 'Restore is not supported for Stripe in this build.',
    upgrade_error_generic: 'Action failed. Please try again later.',
    membership_purchase_title: 'Unlock Unlimited Growth',
    membership_purchase_subtitle: 'Start your Pro experience where data becomes insight',
    membership_purchase_plan_monthly_name: 'Monthly Plan',
    membership_purchase_trial_name: 'Free Trial',
    membership_purchase_trial_desc: 'Try Pro free for 7 days, cancel anytime',
    membership_purchase_trial_period: '7 days',
    membership_purchase_plan_yearly_name: 'Yearly Plan',
    membership_purchase_plan_monthly_desc: 'Flexible billing you can cancel anytime',
    membership_purchase_plan_yearly_desc: 'Limited offer, equivalent to 8.33/month',
    membership_purchase_plan_yearly_tag: 'Save 15%',
    membership_purchase_plan_period_month: 'month',
    membership_purchase_plan_period_year: 'year',
    membership_purchase_popular_badge: 'Most Popular',
    membership_purchase_features_title: 'Pro Exclusive Benefits',
    membership_purchase_free_label: 'Free Users',
    membership_purchase_pro_label: 'Pro Members',
    membership_purchase_ai_badge: 'AI Powered',
    membership_purchase_ai_enhanced_badge: 'AI Enhanced',
    membership_purchase_feat_all_roles_title: 'All AI Personas',
    membership_purchase_feat_all_roles_desc: 'Unlock every companion personality',
    membership_purchase_feat_growth_title: 'Deep Growth Tracking',
    membership_purchase_feat_growth_desc: 'Track mindset and behavior progress in detail',
    membership_purchase_feat_memory_title: 'AI Deep Companionship',
    membership_purchase_feat_memory_desc: 'All roles available, all frequencies adjustable, with exclusive memory',
    membership_purchase_feat_daily_title: 'Personalized Greenhouse Diary',
    membership_purchase_feat_daily_desc: 'Generated daily to record your growth and emotional journey',
    membership_purchase_feat_weekly_title: 'Magic Pen — One-tap Input',
    membership_purchase_feat_weekly_desc: 'One sentence automatically extracts activities, moods, and to-dos',
    membership_purchase_feat_mood_ai_title: 'AI Enhanced Recognition',
    membership_purchase_feat_mood_ai_desc: 'Pro members get AI for more accurate activity and mood classification',
    membership_purchase_feat_star_ai_title: 'AI Smart Linking',
    membership_purchase_feat_star_ai_desc: 'Pro members get AI for more accurate star bottle auto-linking',
    membership_purchase_feat_monthly_title: 'Step-by-Step To-do Completion',
    membership_purchase_feat_monthly_desc: 'Break big goals into small, actionable steps for easier progress',
    membership_purchase_feat_yearly_title: 'Deep Growth Tracking: Weekly/Monthly/Personalized Reports (Coming Soon)',
    membership_purchase_feat_yearly_desc: 'Coming soon, currently in active development',
    membership_purchase_compare_all_roles_free: 'Van persona available',
    membership_purchase_compare_all_roles_pro: 'All 4 AI personas unlocked',
    membership_purchase_compare_growth_free: 'Basic growth insights',
    membership_purchase_compare_growth_pro: 'Deep growth tracking with trend insights',
    membership_purchase_compare_mood_title: 'Activity Mood Classification',
    membership_purchase_compare_mood_free: 'Basic mood categories',
    membership_purchase_compare_mood_pro: 'AI-enhanced recognition with finer accuracy',
    membership_purchase_compare_daily_free: 'Basic diary view',
    membership_purchase_compare_daily_pro: 'Generated personalized diary with richer context',
    membership_purchase_compare_star_bottle_title: 'Star Bottle Auto-Linking',
    membership_purchase_compare_star_bottle_free: 'Rule-based auto-linking',
    membership_purchase_compare_star_bottle_pro: 'AI smart-linking for more accurate matches',
    membership_purchase_compare_todo_free: 'Basic to-do notes',
    membership_purchase_compare_todo_pro: 'Step-by-step task breakdown',
    membership_purchase_compare_report_free: 'Daily basic report',
    membership_purchase_compare_report_pro: 'Weekly/Monthly/Custom reports (in development)',
    membership_purchase_cta: 'Upgrade Now',
    membership_purchase_footer_cancel_anytime: 'Cancel anytime',
    membership_purchase_footer_secure_pay: 'Secure payment',
    profile_help: 'Help & Support',
    profile_privacy: 'Privacy Policy',
    profile_about: 'About',
    profile_change_password: 'Change Password',
    profile_set_password: 'Set Password',
    change_password_title_change: 'Change Password',
    change_password_title_set: 'Set a Login Password',
    change_password_hint: 'After setting a password, you can also sign in with email and password.',
    change_password_new_placeholder: 'New password (min. 6 chars)',
    change_password_confirm_placeholder: 'Confirm new password',
    change_password_save: 'Save',
    change_password_success: 'Password updated',
    change_password_mismatch: 'Passwords do not match',
    change_password_too_short: 'Password must be at least 6 characters',
    change_password_error: 'Update failed, please try again',
    profile_region_settings: 'Region Settings',
    profile_region_settings_desc: 'Used for holiday and weather context. Enter a city/region or use your current location.',
    profile_region_current: 'Current region: {{value}}',
    profile_region_not_set: 'Not set',
    profile_region_placeholder: 'Enter city or region, e.g. Shanghai / Milan',
    profile_region_use_current: 'Use current location',
    profile_region_locating: 'Locating...',
    profile_region_save: 'Save',
    profile_region_saving: 'Saving...',
    profile_region_not_found: 'Region not found. Try a more specific name.',
    profile_region_country_fallback_hint: 'No exact region match. Save country instead: {{value}}',
    profile_region_save_country: 'Save country',
    profile_region_save_error: 'Failed to save region. Please try again.',
    profile_region_locate_error: 'Failed to locate. Please check location permission.',
    profile_root_direction_settings: 'Root Direction Settings',
    profile_root_direction_settings_desc: 'Choose the type for each direction. Changes only affect how it is shown, not the final result.',
    profile_root_direction_reset: 'Reset',
    profile_root_direction_save: 'Save',
    profile_root_direction_saving: 'Saving...',
    profile_root_direction_duplicate_error: 'Direction categories cannot be duplicated. Please edit and save again.',
    profile_root_direction_save_error: 'Save failed. Please try again.',
    profile_logout: 'Log Out',
    profile_plus_only: 'Upgrade to Pro to unlock',
    // ── Membership features ──
} as const;

import { enExtra } from './en.extra';
const en = { ...enCore, ...enExtra } as const;
// Key-set type: zh.ts must have the same keys, but values can be any string
export type TranslationKeys = Record<keyof typeof en, string>;
export default en;
